// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Logo-module--logoContainer--3-ZOW","image":"Logo-module--image--IZEjM"};